export const SET_USER = 'SET_USER'

export const SET_PROFILE = 'SET_PROFILE'

export const SET_USER_ROLES = 'SET_USER_ROLES'



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/user/types.js
// module id = null
// module chunks = 